import styled from 'vue-styled-components'

const StyledTextInputContainer = styled.div`
  position: relative;
`

const StyledTextInputLabel = styled.label`
  display: inline-block;
  color: #000000;
  font-family: 'Gilroy';
  font-weight: ${props => props.theme.fontWeight.semiBold};
  font-size: 0.875rem;
  
  > span {
    margin-left: 8px;
    color: ${props => props.theme.colors.gray};
    font-size: 0.75rem;
    font-weight: ${props => props.theme.fontWeight.normal};
  }
`

const StyledTextInputError = styled.span`
    position: absolute;
    top: 100%;
    left: 0;
    display: inline-block;
    margin-top: 8px;

    color: ${props => props.theme.colors.error};
    font-family: Gilroy;
    font-size: 0.875rem;
    font-weight: ${props => props.theme.fontWeight.normal};
`

const inputProps = {
  error: Boolean,
  value: String
}

const StyledTextInput = styled('input', inputProps)`
  height: 48px;
  width: 100%;
  padding: 0 16px;
  border: 0;
  background-color: ${props => props.error ? props.theme.colors.errorBg : '#fff'};
  
  &:focus {
    box-shadow: 0 8px 16px rgba(40, 88, 162, 0.06);
  }
`

const StyledTextInputField = styled.div`
  position: relative;
  margin-top: 14px;
`

export {
  StyledTextInputContainer,
  StyledTextInputLabel,
  StyledTextInputField,
  StyledTextInput,
  StyledTextInputError
}



// WEBPACK FOOTER //
// ./src/components/TextInput/StyledTextInput.js